import { render, staticRenderFns } from "./AdminProjectsTable.vue?vue&type=template&id=5d1789ae&"
import script from "./AdminProjectsTable.vue?vue&type=script&lang=js&"
export * from "./AdminProjectsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports